/* eslint-disable @typescript-eslint/no-unused-vars */

import { getImagePath } from '@/shared/lib/images';
import React, {
  InputHTMLAttributes,
  memo,
  ReactNode,
  SVGProps,
  useState,
} from 'react';
import { DropzoneProps, useDropzone } from 'react-dropzone';

import { ReactComponent as DeleteImg } from '../../../assets/images/DeleteImg.svg';
import './Input.css';
import { BASE_URL } from '../../api';
import { FileWithPreview } from '../Input/Input';
import { Label } from '../Label/Label';
import { Tooltip } from '../Tooltip/Tooltip';

const ScratchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='11'
    height='20'
    viewBox='0 0 11 20'
    fill='none'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.4471 13.0528L6.44702 14.4294C6.447 14.6729 6.34317 14.8921 6.18936 15.069C6.02529 15.2484 5.78176 15.3253 5.54849 15.3356C5.32162 15.3446 5.06529 15.2267 4.90765 15.0691C4.74231 14.9037 4.64107 14.6615 4.64109 14.4282L4.64111 14.0437L4.64123 11.934C4.64123 11.7802 4.64096 11.6264 4.64068 11.4726C4.64013 11.165 4.63958 10.8574 4.6413 10.5497C4.64261 10.1229 4.74517 9.74098 4.91309 9.35262C4.96693 9.22957 5.03231 9.11293 5.10922 9.00526C5.22971 8.83607 5.3566 8.66559 5.50914 8.52331C6.05261 8.01316 6.80115 7.70295 7.55351 7.7452C8.29947 7.78617 9.04925 8.10528 9.53883 8.68458C9.8131 9.01012 10.0117 9.34977 10.1386 9.75863C10.2181 10.0124 10.2527 10.2905 10.2526 10.5571C10.2543 10.8886 10.2537 11.2189 10.2532 11.5496C10.2529 11.7151 10.2526 11.8806 10.2526 12.0465L10.2524 14.1639C10.2524 14.17 10.2524 14.1761 10.2524 14.1822C10.2525 14.2248 10.2526 14.2674 10.2527 14.3098C10.253 14.4067 10.2533 14.5032 10.2524 14.5996C10.2511 14.9162 10.2152 15.2367 10.1562 15.5468C10.0921 15.8852 9.97291 16.2018 9.84087 16.5184C9.60757 17.0747 9.23713 17.5912 8.80389 18.0091C8.55907 18.2462 8.2822 18.459 7.99509 18.641C7.70413 18.8243 7.39139 18.9602 7.07095 19.0807C6.81589 19.1768 6.55057 19.2448 6.28012 19.2845C5.93662 19.3333 5.5944 19.3679 5.24834 19.3448C4.55494 19.3 3.8923 19.1219 3.27582 18.7976C2.97591 18.6387 2.70163 18.4388 2.43889 18.2248C2.22998 18.0543 2.03902 17.8633 1.86984 17.6532C1.65453 17.3866 1.45203 17.1097 1.2944 16.8034C1.13805 16.5035 1.0099 16.1831 0.918913 15.8588C0.771546 15.3346 0.748505 14.7963 0.748535 14.258L0.748618 12.7814L0.748739 10.6153L0.748868 8.31594L0.748975 6.41132L0.749029 5.43722C0.749052 5.03732 0.796498 4.63102 0.892648 4.24266C0.974696 3.91453 1.1016 3.59282 1.24902 3.28904C1.399 2.97758 1.5964 2.70072 1.80789 2.4277C1.9694 2.21749 2.15141 2.02266 2.35265 1.84962C2.61157 1.62658 2.891 1.41893 3.18836 1.25229C3.79463 0.912604 4.45472 0.729281 5.14429 0.665157C5.41858 0.639507 5.69799 0.644619 5.97227 0.677928C6.31577 0.718924 6.64901 0.772737 6.97584 0.886791C7.63078 1.11362 8.21779 1.45452 8.73045 1.9236C9.69553 2.80664 10.2466 4.09858 10.2516 5.4008C10.2504 5.6456 10.1465 5.86478 9.98501 6.04167C9.82094 6.22112 9.57741 6.29803 9.34414 6.3083C9.11728 6.31729 8.86094 6.19938 8.7033 6.04174C8.53797 5.87641 8.43673 5.63417 8.43674 5.4009C8.43675 5.27765 8.43114 5.15439 8.41941 5.03166C8.37909 4.78068 8.31516 4.53606 8.22701 4.2984C8.12103 4.06072 7.99163 3.83398 7.84106 3.62156C7.67226 3.415 7.48271 3.22552 7.27533 3.05603C7.063 2.90559 6.83636 2.77628 6.59878 2.67038C6.3642 2.58327 6.12234 2.51923 5.87555 2.47942C5.6207 2.45476 5.36527 2.4548 5.11042 2.47839C4.86539 2.51887 4.62644 2.58192 4.39415 2.6681C4.15645 2.77411 3.92968 2.90354 3.71725 3.05413C3.51067 3.22296 3.32117 3.41253 3.15166 3.61992C3.00119 3.83227 2.87186 4.05894 2.76593 4.29653C2.67924 4.52992 2.61538 4.77051 2.57551 5.01599C2.56306 5.14357 2.55625 5.27074 2.55625 5.39867C2.55538 5.6217 2.55565 5.8436 2.55592 6.06549C2.55606 6.17641 2.5562 6.28734 2.55619 6.3984L2.55606 8.77213L2.5559 11.556L2.55577 13.8144C2.55551 13.9012 2.55443 13.9885 2.55336 14.0761C2.54968 14.3753 2.54597 14.6778 2.57422 14.9752C2.6146 15.2237 2.67815 15.4659 2.76546 15.7013C2.87144 15.939 3.00085 16.1657 3.15141 16.3781C3.32022 16.5847 3.50976 16.7742 3.71714 16.9437C3.92947 17.0941 4.15612 17.2234 4.39369 17.3293C4.62826 17.4164 4.87011 17.4805 5.11688 17.5203C5.37151 17.5449 5.62716 17.5448 5.88556 17.5205C6.13161 17.48 6.37153 17.4168 6.60475 17.3303C6.84244 17.2243 7.0692 17.0949 7.28163 16.9443C7.48821 16.7754 7.67771 16.5859 7.84723 16.3785C7.99769 16.1661 8.12702 15.9395 8.23295 15.7019C8.31933 15.4693 8.38305 15.2296 8.42295 14.985C8.44321 14.7654 8.44296 14.545 8.44271 14.3239C8.44268 14.2988 8.44265 14.2737 8.44265 14.2486L8.44278 11.9517L8.44284 10.9135C8.44306 10.8794 8.44347 10.8452 8.44389 10.8109C8.44542 10.6833 8.44696 10.5547 8.43881 10.4275C8.42173 10.3406 8.39896 10.255 8.3707 10.1709C8.33337 10.0941 8.29099 10.0201 8.24385 9.94892C8.1833 9.87957 8.11837 9.81459 8.04908 9.75398C7.97427 9.70469 7.89634 9.66072 7.81581 9.62188C7.73459 9.59485 7.65154 9.57343 7.56742 9.55722C7.48676 9.55213 7.40627 9.5521 7.32561 9.55714C7.23765 9.57429 7.15097 9.59729 7.06579 9.6259C6.98905 9.66324 6.91506 9.70564 6.84383 9.75279C6.77446 9.81334 6.70947 9.87827 6.64886 9.94757C6.59957 10.0224 6.55558 10.1003 6.51673 10.1809C6.48957 10.2625 6.46805 10.346 6.45181 10.4305C6.44352 10.5547 6.44486 10.6802 6.44621 10.8054C6.4463 10.8142 6.4464 10.823 6.44649 10.8317C6.44688 10.8698 6.44722 10.9078 6.44721 10.9457L6.4471 13.0528ZM6.46648 10.2933C6.46855 10.2883 6.47065 10.2832 6.47276 10.2782C6.47067 10.2833 6.46857 10.2883 6.46648 10.2933ZM7.70337 9.57163C7.70839 9.5737 7.7134 9.5758 7.71841 9.5779C7.71338 9.57581 7.70837 9.57372 7.70337 9.57163ZM8.28108 15.5892C8.27552 15.6028 8.26989 15.6164 8.26418 15.6299C8.26982 15.6163 8.27545 15.6027 8.28108 15.5892ZM4.50634 17.3774C4.49275 17.3719 4.47919 17.3662 4.46566 17.3605C4.4793 17.3662 4.49287 17.3718 4.50634 17.3774ZM2.55883 5.1295C2.55931 5.12585 2.55979 5.12219 2.56028 5.11853C2.5598 5.12219 2.55931 5.12584 2.55883 5.1295ZM2.7178 4.40917C2.72336 4.39558 2.72899 4.38202 2.7347 4.36849C2.72907 4.38213 2.72343 4.3957 2.7178 4.40917ZM6.48613 2.62226C6.49973 2.62782 6.5133 2.63345 6.52683 2.63916C6.51318 2.63353 6.49961 2.62789 6.48613 2.62226Z'
      fill='#337CEC'
    />
  </svg>
);

const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    fill='none'
    {...props}
  >
    <path
      fill='#000'
      d='M14.87 2h-3.776c-1.711 0-3.066 0-4.127.144-1.091.147-1.975.459-2.672 1.16-.696.703-1.006 1.592-1.152 2.692C3 7.064 3 8.429 3 10.153v5.68c0 1.467.892 2.725 2.16 3.252-.065-.885-.065-2.127-.065-3.16v-4.874c0-1.247 0-2.321.115-3.182.123-.922.4-1.806 1.112-2.523.712-.717 1.59-.996 2.505-1.12.854-.116 1.92-.116 3.159-.116H14.963c1.238 0 2.302 0 3.156.116A3.493 3.493 0 0 0 14.871 2Z'
    />
    <path
      fill='#000'
      d='M7.034 11.684c0-2.652 0-3.979.819-4.803.818-.824 2.134-.824 4.768-.824h2.793c2.633 0 3.95 0 4.768.824.818.824.818 2.15.818 4.803v4.69c0 2.652 0 3.978-.818 4.802-.818.824-2.135.824-4.768.824H12.62c-2.634 0-3.95 0-4.769-.824-.818-.818-.818-2.15-.818-4.803v-4.689Z'
    />
  </svg>
);

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  withIcon?: boolean;
  label?: string;
  withLinkCopy?: boolean;
  error?: string;
  styles?: string;
  inputStyles?: string;
  isInit?: boolean;
  htmlFor: string;
  files?: any[];
  names?: string[];
  onDelete?: ((arg: number) => void) | (() => void);
  setFiles?: any;
  isClose?: boolean;
  setValue?: any;
  title: string;
  onClear?: () => void;
  format?: 'select' | 'input' | 'dropzone';
  config?: DropzoneProps;
  sizes?: string;
  withPreview?: boolean;
  children?: ReactNode;
}

const DropInput = ({
  label = '',
  error = '',
  styles = '',
  className = '',
  sizes,
  withPreview = true,
  withIcon,
  config = {
    accept: {
      'image/png': ['.png'],
      'image/jpg': ['.jpg'],
      'image/jpeg': ['.jpeg'],
    },
    multiple: false,
    maxFiles: 1,
  },
  htmlFor,
  title,
  isInit,
  isClose,
  value,
  onDelete,
  files,
  names,
  withLinkCopy,
  setFiles,
  setValue,
  onClear,
  format = 'input',
  required,
  children,
  ...props
}: Props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState<number | null>(null);
  const baseStyle: React.CSSProperties = {
    display: 'flex',
    cursor: 'pointer',
  };

  const activeStyle: React.CSSProperties = {
    border: '1px dashed var(--simple-blue-day, #337CEC)',
    background: 'var(--pastel-blue, #EBF1FC)',
  };
  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      const filesWithPreview: FileWithPreview[] = acceptedFiles.map((file) => {
        const fileWithPreview = file as FileWithPreview;
        fileWithPreview.preview = URL.createObjectURL(file);
        return fileWithPreview;
      });
      setFiles([filesWithPreview]);
    },
    [setFiles]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    ...config,
  });

  const style = React.useMemo(() => {
    return {
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
    };
  }, [isDragActive]);

  const handleCopy = async (file: any, index: number) => {
    await navigator.clipboard.writeText(BASE_URL + '/storage/' + file);
    setIsTooltipOpen(index);
    setTimeout(() => {
      setIsTooltipOpen(() => null);
    }, 500);
  };

  return (
    <span className={'flex flex-col gap-[16px]'}>
      <Label htmlFor={htmlFor} label={title} required={required} />
      <button type='button' {...getRootProps({ style })} className='dropdown'>
        <input {...getInputProps()} {...props} name={label} />
        <div className={'flex items-center justify-center gap-[8px]'}>
          {withIcon && <ScratchIcon />}
          <p className='load'>
            Загрузите или перетащите файл <span className='mb'>{sizes}</span>
          </p>
        </div>
      </button>
      {withPreview && !!files?.length && (
        <div className='files'>
          {files?.map((_file: any, index: number) => (
            <div className={'relative mt-[8px]'} key={index}>
              <span className='delete z-0' onClick={() => onDelete(index)}>
                <DeleteImg />
              </span>

              {withLinkCopy && (
                <span
                  className='p z-2 absolute bottom-[8px] right-[8px] flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-full bg-white'
                  onClick={() => handleCopy(_file, index)}
                >
                  <Tooltip
                    isOpen={isTooltipOpen === index}
                    text={'Скопировано'}
                    tooltipClassName='top-[-80px]'
                  >
                    <CopyIcon />
                  </Tooltip>
                </span>
              )}

              {names ? (
                <div className={' overflow-hidden text-sm'}>{names[index]}</div>
              ) : (
                <img
                  alt={_file?.name}
                  className='img'
                  src={
                    typeof _file === 'string'
                      ? getImagePath(_file)
                      : _file?.preview
                  }
                />
              )}
            </div>
          ))}
        </div>
      )}
      {children}
    </span>
  );
};

export default memo(DropInput);
